<template>
    <ClientOnly fallbackTag="div">
        <template #fallback>
            <div v-for="(item, idx) in config.imageConfigs" :key="idx" class="banner-fallback-item" :style="{ height: bannerHeight }">
                <a :href="getSafeLink(item.link) || undefined"
                    :target="isHttpLink(item.link) ? isTarget_Blank() : undefined" class="banner-link">
                    <div
                        v-if="item.isBackground"
                        class="banner-item banner-bg"
                        :style="item.url ? { backgroundImage: `url(${item.url})` } : undefined"
                    >
                        <div :class="`banner-slot-bg banner-slot-${idx}`" v-if="item.slot" v-html="item.slot"></div>
                    </div>
                    <template v-else>
                        <LazyImage class="banner-item" :src="item.url" :fit="'fill'"></LazyImage>
                        <div :class="`banner-slot banner-slot-${idx}`" v-if="item.slot" v-html="item.slot"></div>
                    </template>
                </a>
            </div>
        </template>
        <el-carousel class="banner-item-wrap" trigger="click"
            :height="typeof config.height === 'number' ? config.height + 'px' : '150px'">
            <el-carousel-item v-for="(item, idx) in config.imageConfigs" :key="idx">
                <a :href="getSafeLink(item.link) || undefined"
                    :target="isHttpLink(item.link) ? isTarget_Blank() : undefined" class="banner-link">
                    <div
                        v-if="item.isBackground"
                        class="banner-item banner-bg"
                        :style="item.url ? { backgroundImage: `url(${item.url})` } : undefined"
                    >
                        <div :class="`banner-slot-bg banner-slot-${idx}`" v-if="item.slot" v-html="item.slot"></div>
                    </div>
                    <template v-else>
                        <LazyImage class="banner-item" :src="item.url" :fit="'fill'"></LazyImage>
                        <div :class="`banner-slot banner-slot-${idx}`" v-if="item.slot" v-html="item.slot"></div>
                    </template>
                </a>
            </el-carousel-item>
        </el-carousel>
    </ClientOnly>
</template>

<script setup>
import { computed } from 'vue';
import LazyImage from  "@/components/common/LazyImage/index.vue"

import useLocate from './uses/useLocate.js';
import { getSafeLink, isHttpLink, isTarget_Blank } from '@/utils/globalData.js';
// Props定义
const props = defineProps({
    currentElementIndex: {
        type: Array,
        default: () => [],
    },
    idx: {
        type: Number,
        default: -1,
    },
    parentKeys: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: true,
    },
    config: {
        type: Object,
    },
});

const bannerHeight = computed(() => {
    return typeof props.config?.height === 'number' ? `${props.config.height}px` : '150px';
});

// 计算属性
const currentElementIndexStr = computed(() => {
    return props.currentElementIndex && props.currentElementIndex.length
        ? props.currentElementIndex.join("x")
        : "";
});

const isOpenNewTab = computed(() => {
    let res = false;
    if (isHttpLink(props.config?.link)) {
        res = true;
    }
    return res;
});

// Methods (this is not needed anymore as methods are automatically bound)
const onTextItemClick = () => {
    if (!props.disabled && isHttpLink(props.config?.link)) {
        // Do something when clicked
    }
};


 
</script>

<style scoped>
.banner-fallback-item {
    width: 100%;
}

.banner-item-wrap {
    width: 100%;
    height: 100%;
}

.banner-item {
    width: 100%;
    height: 100%;
}

.banner-bg {
    background-position: center center;
    background-repeat: no-repeat;
    /* 等比按高度铺满容器（高度100%，宽度自适应），并居中展示 */
    background-size: auto 100%;
}

.banner-link {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
}

.banner-slot {
    position: absolute;
    left: 0;
    top: 50px;
}
</style>
